(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e7e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e7e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("72lX3", function(module, exports) {

$parcel$export(module.exports, "ENDPOINT", function () { return $51f9bf6c0a8acf40$export$1a23c4610ef05bed; });
$parcel$export(module.exports, "UPLOAD_ENDPOINT", function () { return $51f9bf6c0a8acf40$export$cdda3773e71b07e4; });
const $51f9bf6c0a8acf40$var$MODE = "DEV" // 'DEV', 'STAGE', 'PROD'
;
const $51f9bf6c0a8acf40$var$ENVIRONMENTS = {
    PROD: {
        ENDPOINT: "https://hiaudio.fr",
        UPLOAD_ENDPOINT: "https://hiaudio.fr/fileUpload"
    },
    STAGE: {
        ENDPOINT: window.location.protocol + "//" + window.location.host,
        UPLOAD_ENDPOINT: window.location.protocol + "//" + window.location.host + "/fileUpload"
    },
    DEV: {
        ENDPOINT: window.location.protocol + "//" + window.location.host,
        UPLOAD_ENDPOINT: window.location.protocol + "//" + window.location.host + "/fileUpload"
    }
};
const $51f9bf6c0a8acf40$export$1a23c4610ef05bed = $51f9bf6c0a8acf40$var$ENVIRONMENTS[$51f9bf6c0a8acf40$var$MODE].ENDPOINT;
const $51f9bf6c0a8acf40$export$cdda3773e71b07e4 = $51f9bf6c0a8acf40$var$ENVIRONMENTS[$51f9bf6c0a8acf40$var$MODE].UPLOAD_ENDPOINT;

});

parcelRegister("7hG31", function(module, exports) {

$parcel$export(module.exports, "uriUserPage", function () { return $54dabcb7a6480b63$export$ff3ad29dbb546598; });
$parcel$export(module.exports, "uriCollectionPage", function () { return $54dabcb7a6480b63$export$36dfaec04418caa7; });
$parcel$export(module.exports, "UserRole", function () { return $54dabcb7a6480b63$export$eb3485a690c2f0b8; });
$parcel$export(module.exports, "LevelPrivacy", function () { return $54dabcb7a6480b63$export$a3c073b335a47d60; });
$parcel$export(module.exports, "PRIVACY_BADGE_STYLE", function () { return $54dabcb7a6480b63$export$eba8c17f4d7a3cd3; });
$parcel$export(module.exports, "PRIVACY_BADGE_TEXT", function () { return $54dabcb7a6480b63$export$ab4fdfae3dcd1a8f; });
$parcel$export(module.exports, "ROLE_BADGE_STYLE", function () { return $54dabcb7a6480b63$export$f25eef55c66a4e9d; });
$parcel$export(module.exports, "startLoader", function () { return $54dabcb7a6480b63$export$8afc507ca675ea0e; });
$parcel$export(module.exports, "cancelLoader", function () { return $54dabcb7a6480b63$export$81e46b314cb8d8e3; });
$parcel$export(module.exports, "callJsonApi", function () { return $54dabcb7a6480b63$export$997d30e836e5c567; });
$parcel$export(module.exports, "looksLikeMail", function () { return $54dabcb7a6480b63$export$706cf9fcefe67c8e; });
$parcel$export(module.exports, "activateGoHomeLink", function () { return $54dabcb7a6480b63$export$3fc781af82c0c660; });
$parcel$export(module.exports, "MEDIA_CONSTRAINTS", function () { return $54dabcb7a6480b63$export$2464c9e69777d386; });

var $72lX3 = parcelRequire("72lX3");
const $54dabcb7a6480b63$export$ff3ad29dbb546598 = "/index.html?userid=";
const $54dabcb7a6480b63$export$36dfaec04418caa7 = "/index.html?collectionid=";
const $54dabcb7a6480b63$export$eb3485a690c2f0b8 = Object.freeze({
    none: 0,
    owner: 1,
    admin: 2,
    member: 3,
    guest: 4
});
const $54dabcb7a6480b63$export$a3c073b335a47d60 = Object.freeze({
    public: 1,
    onlyreg: 2,
    private: 3
});
const $54dabcb7a6480b63$export$eba8c17f4d7a3cd3 = {
    [$54dabcb7a6480b63$export$a3c073b335a47d60.public]: "badge-public",
    [$54dabcb7a6480b63$export$a3c073b335a47d60.onlyreg]: "badge-onlyreg",
    [$54dabcb7a6480b63$export$a3c073b335a47d60.private]: "badge-private"
};
const $54dabcb7a6480b63$export$ab4fdfae3dcd1a8f = {
    [$54dabcb7a6480b63$export$a3c073b335a47d60.public]: "PUBLIC",
    [$54dabcb7a6480b63$export$a3c073b335a47d60.onlyreg]: "REG USERS",
    [$54dabcb7a6480b63$export$a3c073b335a47d60.private]: "PRIVATE"
};
const $54dabcb7a6480b63$export$f25eef55c66a4e9d = {
    [$54dabcb7a6480b63$export$eb3485a690c2f0b8.owner]: "badge-owner",
    [$54dabcb7a6480b63$export$eb3485a690c2f0b8.admin]: "badge-admin",
    [$54dabcb7a6480b63$export$eb3485a690c2f0b8.member]: "badge-member",
    [$54dabcb7a6480b63$export$eb3485a690c2f0b8.guest]: "badge-guest"
};
const $54dabcb7a6480b63$export$8afc507ca675ea0e = (loadingMessage)=>{
    const loaderElement = document.getElementById("loader");
    loaderElement.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;${loadingMessage}`;
    loaderElement.classList.remove("loader-hidden");
};
const $54dabcb7a6480b63$export$81e46b314cb8d8e3 = ()=>{
    const loaderElement = document.getElementById("loader");
    loaderElement.classList.add("loader-hidden");
};
const $54dabcb7a6480b63$export$997d30e836e5c567 = async (apimethod, rqstmethod, body, useLoaderWithText)=>{
    const request = {
        method: rqstmethod || "GET",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    if (body) request.body = JSON.stringify(body);
    try {
        useLoaderWithText && $54dabcb7a6480b63$export$8afc507ca675ea0e(useLoaderWithText);
        const sendRqst = await fetch((0, $72lX3.ENDPOINT) + apimethod, request);
        useLoaderWithText && $54dabcb7a6480b63$export$81e46b314cb8d8e3();
        const respToJson = await sendRqst.json();
        if (respToJson && !respToJson.error) return respToJson;
        else return (respToJson === null || respToJson === void 0 ? void 0 : respToJson.error) || "An error occurred";
    } catch (error) {
        useLoaderWithText && $54dabcb7a6480b63$export$81e46b314cb8d8e3();
        return error;
    }
};
const $54dabcb7a6480b63$export$706cf9fcefe67c8e = (str)=>{
    const lastAtPos = str.lastIndexOf("@");
    const lastDotPos = str.lastIndexOf(".");
    return lastAtPos < lastDotPos && lastAtPos > 0 && str.indexOf("@@") == -1 && lastDotPos > 2 && str.length - lastDotPos > 2;
};
const $54dabcb7a6480b63$export$3fc781af82c0c660 = ()=>{
    const goHomeLink = document.getElementById("goHome");
    if (window.location.host === "localhost:80" || window.location.origin === "http://localhost") goHomeLink.href = window.location.origin + "/index.html";
    else goHomeLink.href = window.location.origin;
};
const $54dabcb7a6480b63$export$95df08bae54cb4df = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const $54dabcb7a6480b63$export$2464c9e69777d386 = {
    audio: {
        echoCancellation: false,
        noiseSuppression: false,
        autoGainControl: false,
        latency: 0,
        channelCount: 1
    }
};

});

parcelRegister("Nsii8", function(module, exports) {

$parcel$export(module.exports, "checkIfTermsAccepted", function () { return $094a86525c89e19a$export$207bec4913bdffa6; });
$parcel$export(module.exports, "generateAcceptTermsModal", function () { return $094a86525c89e19a$export$7ed6abee26b8c64b; });

var $7hG31 = parcelRequire("7hG31");
const $094a86525c89e19a$export$207bec4913bdffa6 = (userprofile, callback)=>{
    (0, $7hG31.cancelLoader)();
    callback(userprofile === null || userprofile === void 0 ? void 0 : userprofile.terms_accepted);
};
const $094a86525c89e19a$export$95d7694256f75341 = ()=>{
    $("#acceptTermsModal").modal({
        backdrop: "static",
        keyboard: false // to prevent closing with Esc button (if you want this too)
    });
    $("#acceptTermsModal").modal("show");
    document.getElementById("buttonAcceptTerms").onclick = $094a86525c89e19a$var$rqstAcceptTerms;
    document.getElementById("buttonRejectTerms").onclick = $094a86525c89e19a$var$rqstRejectTerms;
};
const $094a86525c89e19a$var$rqstAcceptTerms = async ()=>{
    const data = await (0, $7hG31.callJsonApi)("/acceptterms", "PUT", null, "Welcome...");
    if (data.ok) $("#acceptTermsModal").modal("hide");
};
const $094a86525c89e19a$var$rqstRejectTerms = async ()=>{
    const data = await (0, $7hG31.callJsonApi)("/rejectterms", "PUT", null, "Deleting information...");
    if (data.ok) {
        $("#acceptTermsModal").modal("hide");
        window.location.href = window.location.origin;
    }
};
const $094a86525c89e19a$export$7ed6abee26b8c64b = (attachToElem)=>{
    const isModal = document.getElementById("acceptTermsModal");
    if (!isModal) {
        const modalDialog = `<div class="modal fade" id="acceptTermsModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <h5 class="modal-title">Accept Terms</h5>                
                </div>
                <div class="modal-body">
                <p>By clicking on OK you accept the Terms of Use.</p>
                <p>More information at: <span> <a href="${window.location.origin}/static/terms.html" target="_blank">${window.location.origin}/static/terms.html</a></span></p>
                </div>
                <div class="modal-footer">
                <button id="buttonRejectTerms" type="button" class="btn btn-secondary" data-dismiss="modal">Reject</button>
                <button id="buttonAcceptTerms" type="button" class="btn btn-primary">OK</button>
                </div>
            </div>
            </div>
        </div>`;
        document.getElementsByTagName(attachToElem)[0].insertAdjacentHTML("afterend", modalDialog);
    }
    $094a86525c89e19a$export$95d7694256f75341();
};

});

/* TODO: REFACTORING */ 
var $72lX3 = parcelRequire("72lX3");

var $7hG31 = parcelRequire("7hG31");

var $Nsii8 = parcelRequire("Nsii8");
let $166db3e95ea4abca$var$CURRENT_USERNAME = null;
let $166db3e95ea4abca$var$EDIT_STATUS = false;
const $166db3e95ea4abca$var$editUserNameButton = document.getElementById("editusernamebutton");
const $166db3e95ea4abca$var$profilePageTermsAccepted = (termsAccepted)=>{
    if (!termsAccepted) (0, $Nsii8.generateAcceptTermsModal)("main");
};
const $166db3e95ea4abca$var$getUser = async (callback)=>{
    const data = await (0, $7hG31.callJsonApi)("/profile", "GET");
    if (data) callback(data);
};
const $166db3e95ea4abca$var$setUserInfo = (userinfo)=>{
    if (userinfo.ok) {
        (0, $Nsii8.checkIfTermsAccepted)(userinfo, $166db3e95ea4abca$var$profilePageTermsAccepted);
        document.getElementById("profilecard").hidden = false;
        document.getElementById("profilepicture").src = `https://picsum.photos/seed/${userinfo.user_uid}/200`;
        $166db3e95ea4abca$var$CURRENT_USERNAME = userinfo.name;
        document.getElementById("usernameinputfield").value = userinfo.name;
        document.getElementById("userid").innerHTML = userinfo.user_uid;
        document.getElementById("emailaddress").innerHTML = userinfo.email;
        $166db3e95ea4abca$var$deleteProfileHandler(userinfo.user_uid);
        document.getElementById("apicard").hidden = false;
        document.getElementById("apitoken").innerHTML = userinfo.token;
        document.getElementById("curlcode").innerHTML = `$ export JWT="${userinfo.token}"  <br /><br />$ curl ${window.location.protocol}//${window.location.host}/profile   -H "Authorization: Bearer $JWT"`;
        $166db3e95ea4abca$var$copyPasteTokenValue();
    } else document.getElementById("logincard").hidden = false;
};
const $166db3e95ea4abca$var$deleteProfileHandler = (userid)=>{
    document.getElementById("button-deleteprofile").addEventListener("click", async ()=>{
        await $166db3e95ea4abca$var$deleteUserProfile(userid);
    });
};
const $166db3e95ea4abca$var$copyPasteTokenValue = ()=>{
    document.getElementById("copytokenbutton").onclick = ()=>{
        window.prompt("Copy to clipboard: Ctrl+C, Enter", document.getElementById("apitoken").innerHTML);
    };
};
const $166db3e95ea4abca$var$deleteUserProfile = async (userid)=>{
    const api = "/deleteuser/" + userid;
    let userDelete = prompt("To confirm, please enter your User ID", "");
    if (userDelete === userid) {
        const request = {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        try {
            const sendRqst = await fetch((0, $72lX3.ENDPOINT) + api, request);
            const respToJson = await sendRqst.json();
            if (respToJson) window.location.href = window.location.origin;
        } catch (error) {
            alert(error);
        }
    } else if (userDelete !== userid && userDelete !== null) alert("Sorry, the User ID does not match");
};
const $166db3e95ea4abca$var$clickEditButtonHandler = ()=>{
    if ($166db3e95ea4abca$var$EDIT_STATUS) $166db3e95ea4abca$var$disableEdition();
    else {
        $166db3e95ea4abca$var$EDIT_STATUS = true;
        $166db3e95ea4abca$var$editUserNameButton.innerHTML = '<i class="fas fa-save">&nbsp;</i>Save';
        $166db3e95ea4abca$var$enableEdition();
    }
};
const $166db3e95ea4abca$var$enableEdition = ()=>{
    document.getElementById("usernameinputfield").classList.add("italic");
    document.getElementById("usernameinputfield").removeAttribute("readonly");
};
const $166db3e95ea4abca$var$disableEdition = async ()=>{
    const usernameinput = document.getElementById("usernameinputfield");
    const newname = usernameinput.value;
    usernameinput.value = newname.trim();
    if ($166db3e95ea4abca$var$CURRENT_USERNAME === newname) $166db3e95ea4abca$var$setBackToReadOnly();
    else {
        const body = {
            user_name: newname
        };
        const resultNewName = await (0, $7hG31.callJsonApi)("/updateusername", "PATCH", body, "Updating user...");
        if (!resultNewName.ok) {
            usernameinput.classList.add("is-invalid");
            document.getElementById("validationusernameresult").innerText = "Sorry, " + resultNewName;
        } else {
            $166db3e95ea4abca$var$CURRENT_USERNAME = newname;
            $166db3e95ea4abca$var$setBackToReadOnly();
        }
    }
};
const $166db3e95ea4abca$var$setBackToReadOnly = ()=>{
    const usernameinput = document.getElementById("usernameinputfield");
    $166db3e95ea4abca$var$EDIT_STATUS = false;
    $166db3e95ea4abca$var$editUserNameButton.innerHTML = '<i class="fas fa-edit">&nbsp;</i>Edit username';
    usernameinput.setAttribute("readonly", "true");
    usernameinput.classList.remove("is-invalid");
    usernameinput.classList.remove("italic");
    document.getElementById("validationusernameresult").innerText = "";
};
(0, $7hG31.activateGoHomeLink)();
$166db3e95ea4abca$var$editUserNameButton.addEventListener("click", $166db3e95ea4abca$var$clickEditButtonHandler, false);
$166db3e95ea4abca$var$getUser($166db3e95ea4abca$var$setUserInfo);

})();
//# sourceMappingURL=profile.5bbf5371.js.map
